import { AnimationWithSize } from "./AnimationWithSize";

export const OrgChart = () => (
    <AnimationWithSize src="https://dam-cdn.atl.orangelogic.com/AssetLink/8y40h4qsl1sj30uv326g405fh6rch485.riv" />
);
